import { Record } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { tuple_type, list_type, option_type, bool_type, record_type, int32_type, string_type } from "../fable_modules/fable-library-js.4.28.0/Reflection.js";
import { Event$_$reflection, CulturePreset, CulturePresetModule_toInt, EventType, EventTypeModule_toInt, User_$reflection, ToastLevel_$reflection } from "../Shared/Types.js";
import { empty } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { Page, Page_$reflection } from "../Router.js";
import { EventState_$reflection } from "../Pages/Event/State.js";

export class Toast extends Record {
    constructor(Id, Level, Message, DismissAfterMs) {
        super();
        this.Id = Id;
        this.Level = Level;
        this.Message = Message;
        this.DismissAfterMs = (DismissAfterMs | 0);
    }
}

export function Toast_$reflection() {
    return record_type("Client.AppModel.Toast", [], Toast, () => [["Id", string_type], ["Level", ToastLevel_$reflection()], ["Message", string_type], ["DismissAfterMs", int32_type]]);
}

export class ExternalProviderInfo extends Record {
    constructor(Id, Name) {
        super();
        this.Id = Id;
        this.Name = Name;
    }
}

export function ExternalProviderInfo_$reflection() {
    return record_type("Client.AppModel.ExternalProviderInfo", [], ExternalProviderInfo, () => [["Id", string_type], ["Name", string_type]]);
}

export class LoginForm extends Record {
    constructor(Email, Password, Name, IsRegisterMode, IsSubmitting, Error$, IsDebugMode, DebugUsers, SelectedUserId, ExternalProviders, AgreeToTerms, TurnstileToken, TurnstileWidgetId) {
        super();
        this.Email = Email;
        this.Password = Password;
        this.Name = Name;
        this.IsRegisterMode = IsRegisterMode;
        this.IsSubmitting = IsSubmitting;
        this.Error = Error$;
        this.IsDebugMode = IsDebugMode;
        this.DebugUsers = DebugUsers;
        this.SelectedUserId = SelectedUserId;
        this.ExternalProviders = ExternalProviders;
        this.AgreeToTerms = AgreeToTerms;
        this.TurnstileToken = TurnstileToken;
        this.TurnstileWidgetId = TurnstileWidgetId;
    }
}

export function LoginForm_$reflection() {
    return record_type("Client.AppModel.LoginForm", [], LoginForm, () => [["Email", string_type], ["Password", string_type], ["Name", string_type], ["IsRegisterMode", bool_type], ["IsSubmitting", bool_type], ["Error", option_type(string_type)], ["IsDebugMode", bool_type], ["DebugUsers", list_type(User_$reflection())], ["SelectedUserId", string_type], ["ExternalProviders", list_type(ExternalProviderInfo_$reflection())], ["AgreeToTerms", bool_type], ["TurnstileToken", option_type(string_type)], ["TurnstileWidgetId", option_type(string_type)]]);
}

export const LoginFormModule_empty = new LoginForm("", "", "", false, false, undefined, false, empty(), "", empty(), false, undefined, undefined);

export class ForgotPasswordForm extends Record {
    constructor(Email, IsSubmitting, IsSubmitted, Error$) {
        super();
        this.Email = Email;
        this.IsSubmitting = IsSubmitting;
        this.IsSubmitted = IsSubmitted;
        this.Error = Error$;
    }
}

export function ForgotPasswordForm_$reflection() {
    return record_type("Client.AppModel.ForgotPasswordForm", [], ForgotPasswordForm, () => [["Email", string_type], ["IsSubmitting", bool_type], ["IsSubmitted", bool_type], ["Error", option_type(string_type)]]);
}

export const ForgotPasswordFormModule_empty = new ForgotPasswordForm("", false, false, undefined);

export class ResetPasswordForm extends Record {
    constructor(Token, NewPassword, ConfirmPassword, IsSubmitting, IsCompleted, Error$) {
        super();
        this.Token = Token;
        this.NewPassword = NewPassword;
        this.ConfirmPassword = ConfirmPassword;
        this.IsSubmitting = IsSubmitting;
        this.IsCompleted = IsCompleted;
        this.Error = Error$;
    }
}

export function ResetPasswordForm_$reflection() {
    return record_type("Client.AppModel.ResetPasswordForm", [], ResetPasswordForm, () => [["Token", string_type], ["NewPassword", string_type], ["ConfirmPassword", string_type], ["IsSubmitting", bool_type], ["IsCompleted", bool_type], ["Error", option_type(string_type)]]);
}

export const ResetPasswordFormModule_empty = new ResetPasswordForm("", "", "", false, false, undefined);

export class AccountForm extends Record {
    constructor(Name, CurrentPassword, NewPassword, ConfirmPassword, IsSubmittingProfile, IsSubmittingPassword, IsSubmittingDelete, ProfileError, ProfileSuccess, PasswordError, PasswordSuccess, DeleteConfirmText, ShowDeleteConfirm, ConnectedProviders, HasPassword) {
        super();
        this.Name = Name;
        this.CurrentPassword = CurrentPassword;
        this.NewPassword = NewPassword;
        this.ConfirmPassword = ConfirmPassword;
        this.IsSubmittingProfile = IsSubmittingProfile;
        this.IsSubmittingPassword = IsSubmittingPassword;
        this.IsSubmittingDelete = IsSubmittingDelete;
        this.ProfileError = ProfileError;
        this.ProfileSuccess = ProfileSuccess;
        this.PasswordError = PasswordError;
        this.PasswordSuccess = PasswordSuccess;
        this.DeleteConfirmText = DeleteConfirmText;
        this.ShowDeleteConfirm = ShowDeleteConfirm;
        this.ConnectedProviders = ConnectedProviders;
        this.HasPassword = HasPassword;
    }
}

export function AccountForm_$reflection() {
    return record_type("Client.AppModel.AccountForm", [], AccountForm, () => [["Name", string_type], ["CurrentPassword", string_type], ["NewPassword", string_type], ["ConfirmPassword", string_type], ["IsSubmittingProfile", bool_type], ["IsSubmittingPassword", bool_type], ["IsSubmittingDelete", bool_type], ["ProfileError", option_type(string_type)], ["ProfileSuccess", bool_type], ["PasswordError", option_type(string_type)], ["PasswordSuccess", bool_type], ["DeleteConfirmText", string_type], ["ShowDeleteConfirm", bool_type], ["ConnectedProviders", list_type(tuple_type(string_type, string_type))], ["HasPassword", bool_type]]);
}

export const AccountFormModule_empty = new AccountForm("", "", "", "", false, false, false, undefined, false, undefined, false, "", false, empty(), true);

export class ContactForm extends Record {
    constructor(Email, Subject, Description, IsSubmitting, IsSubmitted, Error$, TurnstileToken) {
        super();
        this.Email = Email;
        this.Subject = Subject;
        this.Description = Description;
        this.IsSubmitting = IsSubmitting;
        this.IsSubmitted = IsSubmitted;
        this.Error = Error$;
        this.TurnstileToken = TurnstileToken;
    }
}

export function ContactForm_$reflection() {
    return record_type("Client.AppModel.ContactForm", [], ContactForm, () => [["Email", string_type], ["Subject", string_type], ["Description", string_type], ["IsSubmitting", bool_type], ["IsSubmitted", bool_type], ["Error", option_type(string_type)], ["TurnstileToken", option_type(string_type)]]);
}

export const ContactFormModule_empty = new ContactForm("", "", "", false, false, undefined, undefined);

export class NewEventForm extends Record {
    constructor(Name, EventType, CulturePreset, Date$, IsVisible, IsSubmitting) {
        super();
        this.Name = Name;
        this.EventType = (EventType | 0);
        this.CulturePreset = (CulturePreset | 0);
        this.Date = Date$;
        this.IsVisible = IsVisible;
        this.IsSubmitting = IsSubmitting;
    }
}

export function NewEventForm_$reflection() {
    return record_type("Client.AppModel.NewEventForm", [], NewEventForm, () => [["Name", string_type], ["EventType", int32_type], ["CulturePreset", int32_type], ["Date", string_type], ["IsVisible", bool_type], ["IsSubmitting", bool_type]]);
}

export const NewEventFormModule_empty = new NewEventForm("", EventTypeModule_toInt(new EventType(1, [])), CulturePresetModule_toInt(new CulturePreset(0, [])), "", false, false);

export class HelpPanel extends Record {
    constructor(IsOpen, Chapter, ScrollToId, Content, IsLoading, IsFallback, LastChapter) {
        super();
        this.IsOpen = IsOpen;
        this.Chapter = Chapter;
        this.ScrollToId = ScrollToId;
        this.Content = Content;
        this.IsLoading = IsLoading;
        this.IsFallback = IsFallback;
        this.LastChapter = LastChapter;
    }
}

export function HelpPanel_$reflection() {
    return record_type("Client.AppModel.HelpPanel", [], HelpPanel, () => [["IsOpen", bool_type], ["Chapter", string_type], ["ScrollToId", option_type(string_type)], ["Content", option_type(string_type)], ["IsLoading", bool_type], ["IsFallback", bool_type], ["LastChapter", string_type]]);
}

export const HelpPanelModule_empty = new HelpPanel(false, "index", undefined, undefined, false, false, "index");

export class Model extends Record {
    constructor(CurrentPage, CurrentUser, Events, EventState, IsLoading, Error$, LoginForm, NewEventForm, DeleteEventConfirm, ForgotPasswordForm, ResetPasswordForm, AccountForm, ContactForm, HelpPanel, Toasts) {
        super();
        this.CurrentPage = CurrentPage;
        this.CurrentUser = CurrentUser;
        this.Events = Events;
        this.EventState = EventState;
        this.IsLoading = IsLoading;
        this.Error = Error$;
        this.LoginForm = LoginForm;
        this.NewEventForm = NewEventForm;
        this.DeleteEventConfirm = DeleteEventConfirm;
        this.ForgotPasswordForm = ForgotPasswordForm;
        this.ResetPasswordForm = ResetPasswordForm;
        this.AccountForm = AccountForm;
        this.ContactForm = ContactForm;
        this.HelpPanel = HelpPanel;
        this.Toasts = Toasts;
    }
}

export function Model_$reflection() {
    return record_type("Client.AppModel.Model", [], Model, () => [["CurrentPage", Page_$reflection()], ["CurrentUser", option_type(User_$reflection())], ["Events", list_type(Event$_$reflection())], ["EventState", option_type(EventState_$reflection())], ["IsLoading", bool_type], ["Error", option_type(string_type)], ["LoginForm", LoginForm_$reflection()], ["NewEventForm", NewEventForm_$reflection()], ["DeleteEventConfirm", option_type(string_type)], ["ForgotPasswordForm", ForgotPasswordForm_$reflection()], ["ResetPasswordForm", ResetPasswordForm_$reflection()], ["AccountForm", AccountForm_$reflection()], ["ContactForm", ContactForm_$reflection()], ["HelpPanel", HelpPanel_$reflection()], ["Toasts", list_type(Toast_$reflection())]]);
}

export function init() {
    return new Model(new Page(5, []), undefined, empty(), undefined, true, undefined, LoginFormModule_empty, NewEventFormModule_empty, undefined, ForgotPasswordFormModule_empty, ResetPasswordFormModule_empty, AccountFormModule_empty, ContactFormModule_empty, HelpPanelModule_empty, empty());
}

